module.exports = __webpack_public_path__ + "img/device-apple.b1942510.svg";